import { render, staticRenderFns } from "./DataPointForm.vue?vue&type=template&id=34e75ed8&"
import script from "./DataPointForm.vue?vue&type=script&lang=ts&"
export * from "./DataPointForm.vue?vue&type=script&lang=ts&"
import style0 from "./DataPointForm.vue?vue&type=style&index=0&id=34e75ed8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports